import { PropertyUtils } from '@article/util/property-utils';
import { PropertyValueVO, PropertyVO } from '@project/components/article/model/vo/property.vo';

export class Properties<T extends string> {

  private readonly _propertyVos: PropertyVO[]

  constructor(propertyVos: PropertyVO[]) {
    this._propertyVos = propertyVos ?? [];
  }

  public get vos(): PropertyVO[] {
    return this._propertyVos;
  }

  public getSingle(name: T) {
    return PropertyUtils.getPropertyByName(this._propertyVos, name)
  }

  public getMultiple(name: T) {
    return PropertyUtils.getPropertyValuesByPropertyName(this._propertyVos, name)
  }

  public getInt(name: T) {
    return PropertyUtils.getIntPropertyValue(this._propertyVos, name)
  }

  public getFloat(name: T) {
    return PropertyUtils.getFloatPropertyValue(this._propertyVos, name)
  }

  public getString(name: T) {
    return PropertyUtils.getStringPropertyValue(this._propertyVos, name)
  }

  public getStrings(name: T) {
    return PropertyUtils.getStringPropertyValues(this._propertyVos, name)
  }

  public getBoolean(name: T) {
    return PropertyUtils.getBooleanPropertyValue(this._propertyVos, name)
  }

  public setInt(name: T, value: number, overwriteExistingValues: boolean = true, isTransientProperty: boolean = false): void {
    PropertyUtils.setIntPropertyValue(this._propertyVos, name, value, overwriteExistingValues, isTransientProperty)
  }

  public setFloat(name: T, value: number, overwriteExistingValues: boolean = true, isTransientProperty: boolean = false): void {
    PropertyUtils.setFloatPropertyValue(this._propertyVos, name, value, overwriteExistingValues, isTransientProperty)
  }

  public setString(name: T, value: string, overwriteExistingValues: boolean = true, isTransientProperty: boolean = false): void {
    PropertyUtils.setStringPropertyValue(this._propertyVos, name, value, overwriteExistingValues, isTransientProperty)
  }

  public setStrings(name: T, values: string[], overwriteExistingValues: boolean = true, isTransientProperty: boolean = false): void {
    PropertyUtils.setStringPropertyValues(this._propertyVos, name, values, overwriteExistingValues, isTransientProperty)
  }

  public setBoolean(name: T, value: boolean, overwriteExistingValues: boolean = true, isTransientProperty: boolean = false): void {
    PropertyUtils.setBooleanPropertyValue(this._propertyVos, name, value, overwriteExistingValues, isTransientProperty)
  }

  public setSingle(name: T, value: PropertyValueVO, overwriteExistingValues: boolean = true, isTransientProperty: boolean = false): void {
    PropertyUtils.setSinglePropertyValue(this._propertyVos, name, value, overwriteExistingValues, isTransientProperty)
  }

  public setMultiple(name: T, values: PropertyValueVO[],
                     overwriteExistingValues: boolean = true, addAsFirstValue: boolean = false,
                     isTransientProperty: boolean = false): void {
    PropertyUtils.setPropertyValues(this._propertyVos, name, values, overwriteExistingValues, isTransientProperty)
  }

  public remove(name: T) {
    PropertyUtils.removePropertiesByName(this._propertyVos, name);
  }
}
